/** Reusable iPhone 14-style frame (200 × 340 viewBox) */
function IPhoneFrame() {
  return (
    <>
      {/* Outer frame */}
      <rect x="4" y="4" width="192" height="332" rx="40" fill="#1c1c1e" />
      {/* Side buttons */}
      <rect x="0" y="80" width="4" height="28" rx="2" fill="#3a3a3c" />
      <rect x="0" y="116" width="4" height="42" rx="2" fill="#3a3a3c" />
      <rect x="0" y="166" width="4" height="42" rx="2" fill="#3a3a3c" />
      <rect x="196" y="100" width="4" height="56" rx="2" fill="#3a3a3c" />
      {/* Screen */}
      <rect x="12" y="12" width="176" height="316" rx="32" fill="#f2f2f7" />
      {/* Dynamic Island */}
      <rect x="68" y="18" width="64" height="16" rx="8" fill="#1c1c1e" />
    </>
  );
}

/** iOS status bar content (inside screen, y offset passed as prop) */
function IosStatusBar({ y = 44 }: { y?: number }) {
  return (
    <>
      {/* Time */}
      <text x="28" y={y} fontSize="9.5" fontWeight="700" fill="#000">9:41</text>
      {/* Signal bars */}
      <rect x="142" y={y - 8} width="2.5" height="5" rx="1" fill="#000" />
      <rect x="146" y={y - 10} width="2.5" height="7" rx="1" fill="#000" />
      <rect x="150" y={y - 13} width="2.5" height="10" rx="1" fill="#000" />
      <rect x="154" y={y - 15} width="2.5" height="12" rx="1" fill="#000" />
      {/* WiFi */}
      <text x="160" y={y} fontSize="9" fill="#000">◈</text>
      {/* Battery */}
      <rect x="170" y={y - 12} width="18" height="9" rx="2" fill="none" stroke="#000" strokeWidth="1" />
      <rect x="188" y={y - 9.5} width="2" height="4" rx="1" fill="#000" opacity="0.4" />
      <rect x="171" y={y - 11} width="14" height="7" rx="1.5" fill="#000" />
    </>
  );
}

export function IpGuideIos() {
  return (
    <div className="space-y-6">
      {/* Step 1 */}
      <div className="flex gap-3">
        <span className="shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center mt-0.5">
          1
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-700 mb-3">
            <strong>Einstellungen</strong> öffnen und auf <strong>„WLAN"</strong> tippen.
          </p>
          <svg viewBox="0 0 200 340" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-[190px] mx-auto block" aria-hidden="true">
            <IPhoneFrame />
            <IosStatusBar y={44} />
            {/* Einstellungen header */}
            <rect x="12" y="50" width="176" height="36" fill="#f2f2f7" />
            <text x="100" y="74" textAnchor="middle" fontSize="15" fontWeight="700" fill="#000">Einstellungen</text>
            {/* Search bar */}
            <rect x="20" y="90" width="160" height="24" rx="10" fill="#e5e5ea" />
            <text x="100" y="106" textAnchor="middle" fontSize="10" fill="#8e8e93">Suchen</text>
            {/* Group 1 – highlight WLAN row */}
            <rect x="12" y="122" width="176" height="1" fill="#c6c6c8" />
            <rect x="12" y="123" width="176" height="42" fill="#fff" />
            {/* Flugmodus row */}
            <rect x="20" y="131" width="22" height="22" rx="6" fill="#ff9f0a" />
            <text x="31" y="146" textAnchor="middle" fontSize="13" fill="#fff">✈</text>
            <text x="52" y="146" fontSize="13" fill="#000">Flugmodus</text>
            <rect x="12" y="165" width="176" height="0.5" fill="#e5e5ea" />
            {/* WLAN row – tapped / highlighted */}
            <rect x="12" y="165" width="176" height="42" fill="#d1e4ff" />
            <rect x="20" y="173" width="22" height="22" rx="6" fill="#007aff" />
            <text x="31" y="188" textAnchor="middle" fontSize="12" fill="#fff">◈</text>
            <text x="52" y="188" fontSize="13" fill="#000" fontWeight="500">WLAN</text>
            <text x="180" y="188" textAnchor="end" fontSize="11" fill="#8e8e93">ALB ›</text>
            <rect x="12" y="207" width="176" height="0.5" fill="#c6c6c8" />
            {/* Bluetooth */}
            <rect x="12" y="207" width="176" height="42" fill="#fff" />
            <rect x="20" y="215" width="22" height="22" rx="6" fill="#007aff" />
            <text x="31" y="230" textAnchor="middle" fontSize="12" fill="#fff">⚡</text>
            <text x="52" y="230" fontSize="13" fill="#000">Bluetooth</text>
            <text x="180" y="230" textAnchor="end" fontSize="11" fill="#8e8e93">An ›</text>
            <rect x="12" y="249" width="176" height="0.5" fill="#c6c6c8" />
            {/* Tap indicator */}
            <circle cx="100" cy="186" r="38" fill="rgba(0,122,255,0.1)" />
          </svg>
        </div>
      </div>

      {/* Step 2 */}
      <div className="flex gap-3">
        <span className="shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center mt-0.5">
          2
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-700 mb-3">
            Neben dem verbundenen Netzwerk auf das <strong>ⓘ</strong> tippen.
          </p>
          <svg viewBox="0 0 200 340" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-[190px] mx-auto block" aria-hidden="true">
            <IPhoneFrame />
            <IosStatusBar y={44} />
            {/* WLAN nav bar */}
            <rect x="12" y="50" width="176" height="36" fill="#f2f2f7" />
            <text x="30" y="74" fontSize="12" fill="#007aff">‹ Einst.</text>
            <text x="100" y="74" textAnchor="middle" fontSize="14" fontWeight="700" fill="#000">WLAN</text>
            {/* WLAN toggle */}
            <rect x="12" y="90" width="176" height="0.5" fill="#c6c6c8" />
            <rect x="12" y="90" width="176" height="38" fill="#fff" />
            <text x="24" y="113" fontSize="13" fill="#000">WLAN</text>
            <rect x="152" y="100" width="28" height="16" rx="8" fill="#34c759" />
            <circle cx="172" cy="108" r="7" fill="#fff" />
            <rect x="12" y="128" width="176" height="0.5" fill="#c6c6c8" />
            {/* Connected network label */}
            <rect x="12" y="128" width="176" height="22" fill="#f2f2f7" />
            <text x="24" y="143" fontSize="10" fill="#6c6c70" fontWeight="600">MEIN NETZWERK</text>
            <rect x="12" y="150" width="176" height="0.5" fill="#c6c6c8" />
            {/* ALB-WLAN row */}
            <rect x="12" y="150" width="176" height="42" fill="#fff" />
            {/* Checkmark */}
            <text x="26" y="174" fontSize="13" fill="#007aff" fontWeight="600">✓</text>
            <text x="44" y="175" fontSize="13" fill="#000">ALB-WLAN</text>
            {/* Info (i) button – highlighted in orange */}
            <circle cx="172" cy="171" r="13" fill="rgba(255,149,0,0.15)" />
            <circle cx="172" cy="171" r="9" fill="none" stroke="#ff9500" strokeWidth="2" />
            <text x="172" y="175.5" textAnchor="middle" fontSize="11" fill="#ff9500" fontWeight="700">i</text>
            <rect x="12" y="192" width="176" height="0.5" fill="#c6c6c8" />
            {/* Other networks label */}
            <rect x="12" y="192" width="176" height="22" fill="#f2f2f7" />
            <text x="24" y="207" fontSize="10" fill="#6c6c70" fontWeight="600">ANDERE NETZWERKE</text>
            <rect x="12" y="214" width="176" height="0.5" fill="#c6c6c8" />
            {/* Other network rows */}
            <rect x="12" y="214" width="176" height="38" fill="#fff" />
            <text x="24" y="236" fontSize="12.5" fill="#888">Gäste-WLAN</text>
            <text x="180" y="236" textAnchor="end" fontSize="10" fill="#c6c6c8">›</text>
            {/* Pulse around (i) button */}
            <circle cx="172" cy="171" r="18" fill="rgba(255,149,0,0.08)" />
          </svg>
        </div>
      </div>

      {/* Step 3 */}
      <div className="flex gap-3">
        <span className="shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center mt-0.5">
          3
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-700 mb-3">
            Im Bereich <strong>„IPv4-Adresse"</strong> steht deine IP – rot markiert.
          </p>
          <svg viewBox="0 0 200 340" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-[190px] mx-auto block" aria-hidden="true">
            <IPhoneFrame />
            <IosStatusBar y={44} />
            {/* Nav bar */}
            <rect x="12" y="50" width="176" height="36" fill="#f2f2f7" />
            <text x="28" y="74" fontSize="12" fill="#007aff">‹ WLAN</text>
            <text x="100" y="74" textAnchor="middle" fontSize="14" fontWeight="700" fill="#000">ALB-WLAN</text>
            {/* Section: IP-KONFIGURATION */}
            <rect x="12" y="90" width="176" height="0.5" fill="#c6c6c8" />
            <rect x="12" y="90" width="176" height="22" fill="#f2f2f7" />
            <text x="24" y="105" fontSize="10" fill="#6c6c70" fontWeight="600">IP-KONFIGURATION</text>
            <rect x="12" y="112" width="176" height="0.5" fill="#c6c6c8" />
            <rect x="12" y="112" width="176" height="38" fill="#fff" />
            <text x="24" y="134" fontSize="12.5" fill="#000">Konfiguration</text>
            <text x="180" y="134" textAnchor="end" fontSize="12" fill="#8e8e93">Automatisch ›</text>
            <rect x="12" y="150" width="176" height="0.5" fill="#c6c6c8" />
            {/* IPv4 row – red border highlight */}
            <rect x="12" y="150" width="176" height="42" fill="#fff" />
            <rect x="10" y="148" width="180" height="46" rx="4" fill="none" stroke="#ef4444" strokeWidth="2" />
            <text x="24" y="168" fontSize="10.5" fill="#6c6c70">IPv4-Adresse</text>
            <text x="180" y="175" textAnchor="end" fontSize="14" fontWeight="700" fill="#1a1a1a">192.168.1.42</text>
            {/* Red arrow */}
            <polygon points="193,171 200,166 200,176" fill="#ef4444" />
            <rect x="12" y="192" width="176" height="0.5" fill="#c6c6c8" />
            <rect x="12" y="192" width="176" height="38" fill="#fff" />
            <text x="24" y="210" fontSize="10.5" fill="#6c6c70">Subnetzmaske</text>
            <text x="180" y="217" textAnchor="end" fontSize="12.5" fill="#8e8e93">255.255.255.0</text>
            <rect x="12" y="230" width="176" height="0.5" fill="#c6c6c8" />
            <rect x="12" y="230" width="176" height="38" fill="#fff" />
            <text x="24" y="248" fontSize="10.5" fill="#6c6c70">Router</text>
            <text x="180" y="255" textAnchor="end" fontSize="12.5" fill="#8e8e93">192.168.1.1</text>
          </svg>
        </div>
      </div>
    </div>
  );
}
